import React, { useState } from "react";
import Header from "../layout/header";
import jwt_decode from "jwt-decode";
import Confetti from "react-confetti";
import "../components/common/index.scss";
import Footer from "../components/global/FooterComponent";
import feedbackTitle from "../assets/img/bg/feeback_title.png";
import feedback01 from "../assets/img/icons/feedback_01.png";
import feedback02 from "../assets/img/icons/feedback_02.png";
import feedback03 from "../assets/img/icons/feedback_03.png";
import feedback04 from "../assets/img/icons/feedback_04.png";
import feedback05 from "../assets/img/icons/feedback_05.png";
import feedbackBar from "../assets/img/bg/feedback_bar.png";
import feedbackMudraKosh from "../assets/img/icons/mudrakosh.png";
import bgBorder from "../assets/img/bg/border.svg";
import kalashIcon from "../assets/img/icons/kalash.png";
import email48 from "../assets/img/icons/icons-gmail.png";
import whatsapp48 from "../assets/img/icons/whatsapp-48.png";
import twitter48 from "../assets/img/icons/twitter-48.png";
import successCheck from "../svg/successCheck.svg";
import iIcon from "../svg/iIcon.svg";
import { feedbackTextValues } from "../constants";
import {
  getProfileDetails,
  submitFeedback,
} from "../store/apiCalls/profileDetails";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  FetchProfileDetails,
  setUpProfile,
} from "../containers/autherFlow/personalDetails/queries";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import copy from "copy-to-clipboard";
import { isMobile } from "react-device-detect";
import {
  EmailShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { SERVER_URL } from "../config";
import Button from "../components/common/Button";

const initialState = {
  showFeedbackModal: false,
  skipModal: false,
  congratsModal: false,
  referModal: false,
  congratsPreview: false,
};

const ThanksForRegistration = () => {
  const [feedbackScore, setFeedbackScore] = useState(null);
  const [feedbackValue, setFeedback] = useState("");
  const [modalState, setModalState] = useState(initialState);
  const [mobileAlert, setMobileAlert] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  const { user, userLoginDetails } = useSelector(
    (state) => state?.LoginReducer
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = localStorage.usertoken
    ? jwt_decode(localStorage.usertoken)
    : "";
  const headers = { Authorization: `Bearer ${localStorage.usertoken || ""}` };

  const handleFeedback = (e) => {
    setFeedbackScore(e.target.value);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const queryParams = {
      params: { id: id },
      data: {
        userId: id,
        rating: parseInt(feedbackScore),
        feedbackText: feedbackValue,
        feedback: true,
      },
      headers,
    };

    const resPayload = await submitFeedback(queryParams);
    console.log(resPayload);
    if (resPayload.data.success) {
      setModalState({ ...modalState, congratsModal: true });
      refetch();
    } else {
      toast.error(resPayload.data.error);
    }
  };

  const handleFeedbackModalStat = async () => {
    setModalState({ ...modalState, congratsModal: false });
  };

  const publishSuccessHandler = (_success) => {
    if (_success?.data?.success) {
      setModalState({
        ...modalState,
        congratsModal: false,
        congratsPreview: true,
      });
    } else {
      toast.error(_success?.data?.error);
      setModalState(initialState);
    }
    dispatch({
      type: "SET_LOADER",
      payload: false,
    });
  };

  const { mutate: PublishProfile } = setUpProfile(publishSuccessHandler);

  const handlePublishProfile = () => {
    dispatch({
      type: "SET_LOADER",
      payload: true,
    });
    const queryParams = {
      params: { id: id },
      data: { publishProfile: true, isSetupProfile: true },
      headers: { ...headers, "Content-Type": "application/json" },
    };

    PublishProfile(queryParams);
  };

  const handleCongratsModalClose = (publish = false) => {
    if (publish) {
      handlePublishProfile();
      setModalState({
        ...modalState,
        congratsPreview: true,
        congratsModal: false,
      });
    } else {
      setModalState({ ...modalState, referModal: true, congratsModal: false });
    }
  };

  const handleRedirectDashboard = (e, path = "/registration") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  const handleCongratsPreviewModalClose = () => {
    setModalState(initialState);
  };

  const handleRedirect = (e, path = "/") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  const fetchdata = async () => {
    const params = { id: user?._id };
    const headers = { Authorization: `Bearer ${userLoginDetails?.token}` };
    return getProfileDetails(headers, params);
  };

  const sucessHandler = (fetchedData) => {
    let resData = fetchedData?.data?.data;
    const code = resData?.promoCode || "XXXXXXX";
    setReferralCode(code);
  };

  const { refetch } = FetchProfileDetails(fetchdata, sucessHandler);

  const handleCodeCopy = (e) => {
    copy(code);
    e.target.textContent = "Copied";
    e.target.style.setProperty("color", "#404040");
  };

  const handleReferModalClose = (publish = false) => {
    if (publish) {
      handlePublishProfile();
      setModalState({ ...modalState, referModal: false });
    } else {
      setModalState(initialState);
    }
  };

  const shareUrl = SERVER_URL;
  const title = `I have just signed up as a researcher with Vikramshila Education. It is an Indian Open Access Platform for Research Publishing. I really liked their mission to create multiple digital platforms to help disseminate research, primarily from the developing world. I would like you to be a part of this movement. 
    
    Use the referral code ${referralCode} to register on the "https://vikramshilaedu.in/" and be a part of the largest database of research professionals. You will earn 250 mudras as welcome bonus (INR 250), which you can use to publish your own research paper. 
    
    "https://vikramshilaedu.in/registration"`;

  return (
    <>
      <Header />
      <div className="min-vh-100 d-flex justify-content-center align-items-center">
        <div style={{ marginTop: "120px" }}>
          <h1 className="text-center feedbackReward">
            <b>Thank you for registering</b>
          </h1>
          <form onSubmit={(e) => handleFormSubmit(e)}>
            <div>
              <div className="">
                <div className="modal-header pb-0">
                  <span className="smallSubText sr-color">
                    Before you publish your profile
                  </span>
                  <h5 className="modal-title" style={{ color: "#FF8300" }}>
                    WE WANT TO KNOW HOW WE DID
                  </h5>
                  {/* <button type="button" className="btn-close" /> */}
                </div>
                <div className="modal-body pt-0 pb-0">
                  <div className="px-2 feedbackContent">
                    <p>Feedback will help us improve your experience</p>
                    <div className="feedbackSmiley mt-4 mb-3">
                      <div className="feedbackTitle">
                        <img src={feedbackTitle} alt="#" />
                      </div>
                      <ul>
                        <li>
                          <label className="smileyWrap">
                            <input
                              value={1}
                              type="radio"
                              name="rating"
                              required
                              onChange={handleFeedback}
                            />
                            <span>
                              <img src={feedback01} alt="#" />
                            </span>
                          </label>
                        </li>
                        <li>
                          <label className="smileyWrap">
                            <input
                              value={2}
                              type="radio"
                              name="rating"
                              required
                              onChange={handleFeedback}
                            />
                            <span>
                              <img src={feedback02} alt="#" />
                            </span>
                          </label>
                        </li>
                        <li>
                          <label className="smileyWrap">
                            <input
                              value={3}
                              type="radio"
                              name="rating"
                              required
                              onChange={handleFeedback}
                            />
                            <span>
                              <img src={feedback03} alt="#" />
                            </span>
                          </label>
                        </li>
                        <li>
                          <label className="smileyWrap">
                            <input
                              value={4}
                              type="radio"
                              name="rating"
                              required
                              onChange={handleFeedback}
                            />
                            <span>
                              <img src={feedback04} alt="#" />
                            </span>
                          </label>
                        </li>
                        <li>
                          <label className="smileyWrap">
                            <input
                              value={5}
                              type="radio"
                              name="rating"
                              required
                              onChange={handleFeedback}
                            />
                            <span>
                              <img src={feedback05} alt="#" />
                            </span>
                          </label>
                        </li>
                      </ul>
                      <div className="feedbackBar">
                        <img src={feedbackBar} alt="#" />
                      </div>
                    </div>
                    <div>
                      <label className="labelForm sr-color px-2">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: feedbackTextValues[feedbackScore],
                          }}
                        />
                      </label>
                      <div className="mx-2 px-1">
                        {feedbackScore && (
                          <textarea
                            onChange={(e) => setFeedback(e.target.value)}
                            className="fieldForm popup-textarea"
                            name="suggestion"
                            placeholder="We are listening intently..."
                            required
                          ></textarea>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer pt-0">
                  <button
                    className="button button-primary w-50"
                    type="submit"
                    disabled={!(feedbackScore && feedbackValue)}
                  >
                    Submit
                  </button>
                  <div className="feedbackReward pt-0">
                    <p>
                      Share your feedback and get <b>500 Mudras!</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {modalState.congratsModal && (
        <>
          <Modal
            show={modalState.congratsModal}
            id="congratsModal"
            tabIndex={-1}
            dialogClassName="congrats-modal-dialog"
          >
            <Confetti width={"450px"} height={"300px"} numberOfPieces={100} />
            <div>
              <div className="">
                <div className="modal-header">
                  <h5 className="modal-title bigText pr-color">
                    CONGRATULATIONS
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={(e) => handleFeedbackModalStat()}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body pt-0 pb-0">
                  <div className="px-2 text-center">
                    <div className="mudrakoshBox">
                      <p>500 Mudras DEPOSITED</p>
                      <span>
                        <img src={feedbackMudraKosh} alt="#" />
                      </span>
                    </div>
                    <div className="divideWrap">
                      <img src={bgBorder} alt="#" />
                    </div>
                    {/* <p className="typo-wrap">
                      Would You like to earn 250 mudras more?{" "}
                    </p> */}
                  </div>
                </div>
                <div className="modal-footer pt-2">
                  {/* <a
                    href="javascript:void(0);"
                    className="linkBtn"
                    onClick={(e) => handleCongratsModalClose(false)}
                  >
                    Refer and Earn
                  </a> */}
                  {/* <button
                    className="custom_button ms-2"
                    onClick={(e) => handleCongratsModalClose(true)}
                  >
                    No, Publish my Profile
                  </button> */}
                  <button
                    className="custom_button ms-2"
                    onClick={(e) => handleCongratsModalClose(true)}
                  >
                    Publish my Profile
                  </button>
                  <div className="rewardNote">
                    <small>
                      <img src={iIcon} alt="iIcon" />
                      You will be able to check your reward in the “Mudrakosh”
                      section
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </>
      )}
      {modalState.congratsPreview && (
        <>
          <Modal
            size="md md-x"
            dialogClassName="modal-dialog-centered md-x"
            show={modalState.congratsPreview}
            className="founder-message success-modal md-x"
            id="successMsg"
            tabIndex={-1}
            keyboard={false}
            backdrop="static"
          >
            <Confetti width={"400px"} height={"300px"} numberOfPieces={100} />
            <Modal.Header className="justify-content-center pb-1 px-0 pt-0">
              <div className="header-before">
                <img src={successCheck} alt="success" />
              </div>
              <Modal.Title className="mt-5">
                <div className="mb-3 pt-4">YOU ARE AWESOME!</div>
              </Modal.Title>
            </Modal.Header>
            <div
              className="text-center label-info color-black"
              dangerouslySetInnerHTML={{
                __html:
                  "You have registered and joined the mission successfully.",
              }}
            />
            <Modal.Footer className="justify-content-center pt-3 d-grid">
              <Button
                handleClick={(e) =>
                  isMobile
                    ? (setMobileAlert(true), handleCongratsPreviewModalClose())
                    : handleRedirectDashboard(e, "/dashboard")
                }
                // handleRedirectDashboard(e, "/dashboard")
                title="Start Your Publishing Journey Now"
                type="button"
              />
              <div className="text-center">
                <Link
                  to="/"
                  onClick={(e) => handleRedirect(e, "/")}
                  className="link text-decoration-none f-700"
                >
                  Home
                </Link>
              </div>
            </Modal.Footer>
          </Modal>
        </>
      )}
      {modalState.referModal && (
        <Modal
          show={modalState.referModal}
          id="referModal"
          tabIndex={-1}
          className="md-x"
        >
          <div>
            <div className="modal-content border-0 referContent">
              <div className="modal-header pb-0">
                <h5 className="modal-title referText">Refer and Earn</h5>
                <p className="bigSubText">Invite 5 friends to register</p>
                <div className="mudraCount">
                  <span>
                    <b>Earn</b>
                    <br />
                    250 Mudras
                  </span>
                  <i>
                    <img src={kalashIcon} alt="#" />
                  </i>
                </div>
                <button
                  type="button"
                  className="btn-close text-white"
                  onClick={(e) => {
                    setModalState(initialState);
                  }}
                  aria-label="Close"
                />
              </div>
              <div className="modal-body pt-0 pb-0">
                <div className="px-2 text-center shareModal">
                  <div className="referStep">
                    <ul>
                      <li>
                        <span>
                          <b className="icon-persons" />
                        </span>
                        Invite 5 friends to register
                      </li>
                      <li>
                        <span>
                          <b className="icon-register" />
                        </span>
                        Your friends register
                      </li>
                      <li>
                        <span>
                          <b className="icon-wallet" />
                        </span>
                        You receive 250 Mudras{" "}
                      </li>
                    </ul>
                  </div>
                  <p className="receiveText">
                    Your friends also receive 250 Mudras each as joining bonus
                    after registration
                  </p>
                  <div className="socialShare">
                    <small>Invite via</small>
                    <ul className="socialRefer">
                      <li>
                        <EmailShareButton
                          separator=" "
                          subject="Your friend has invited you to join Mission Vikramshila"
                          body={title}
                          url=" "
                          shareUrl={title}
                        >
                          <img src={email48} alt="#" />
                        </EmailShareButton>
                      </li>

                      <li>
                        <WhatsappShareButton
                          url={shareUrl}
                          title={title}
                          separator=" "
                          className="Demo__some-network__share-button"
                        >
                          <img src={whatsapp48} alt="#" />
                        </WhatsappShareButton>
                      </li>
                      <li>
                        <TwitterShareButton
                          url={shareUrl}
                          title={title}
                          separator=" "
                          className="Demo__some-network__share-button"
                        >
                          <img src={twitter48} alt="#" />
                        </TwitterShareButton>
                      </li>
                    </ul>
                  </div>
                  <div className="divideLine">
                    <b>or</b>
                  </div>
                  <div className="codeBelow ">
                    <small>Refer using your unique code</small>
                    <div className="codeWrap">
                      <p id="#code" className="pr-color flex-fill">
                        {referralCode || "XXXXXXX"}
                      </p>
                      <p
                        onClick={(e) => handleCodeCopy(e)}
                        className="sr-color"
                      >
                        <b id="code" className="icon-copy sr-color" />
                        &nbsp;&nbsp;Copy Code
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer pt-0 pb-0">
                <a
                  onClick={(e) => handleReferModalClose(false)}
                  className="linkBtn mr-5"
                >
                  I’ll do it later
                </a>
                <button
                  onClick={(e) => handleReferModalClose(true)}
                  className="button button-primary ms-2"
                >
                  Publish Profile
                </button>
                <div className="rewardNoteRefer">
                  <small>
                    <i></i>
                    <p>
                      Receiving 250 Mudras is conditional to 5 friends
                      registering with us
                      <br />
                      You will be able to check your reward in the “Mudrakosh”
                      section
                    </p>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      <Modal
        show={mobileAlert}
        size="md"
        tabIndex={-1}
        dialogClassName="modal-dialog-centered authorModal"
      >
        <Modal.Header className="modal-header pb-0">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={(e) => setMobileAlert(false)}
          />
          <Modal.Title className="modal-title pl-0">
            <h2 className="fontsizeshastra ml-4">Note</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0">
          <div className="grantDetails pl-2 pr-2 mb-3">
            <div className="writeYourContent pb-0 pt-0">
              <p className="mb-0 text-left">
                <p className="yellowTextWelcome text-center blackColorTestRegst">
                  For a better publishing experience, article submission is
                  currently supported on desktop only. Please log in again from
                  your desktop.
                </p>
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Footer />
    </>
  );
};

export default ThanksForRegistration;
